import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

export interface ModuleFile {
  id: string;
  name: string;
  type: 'pdf' | 'docx' | 'xlsx';
  moduleId: number;
  description: string;
}

export const MODULE_FILES: ModuleFile[] = [
  {
    id: 'module-1-pdf',
    name: 'SJA - Module 1_The Mindset You Need to Succeed.pdf',
    type: 'pdf',
    moduleId: 1,
    description: 'Module 1 Course Material'
  },
  {
    id: 'module-1-homework',
    name: 'SJA - Module 1_Homework.docx',
    type: 'docx',
    moduleId: 1,
    description: 'Module 1 Homework Assignment'
  },
  {
    id: 'module-2-pdf',
    name: 'SJA - Module 2_ Smooth Sailing Networking.pdf',
    type: 'pdf',
    moduleId: 2,
    description: 'Module 2 Course Material'
  },
  {
    id: 'module-2-homework',
    name: 'SJA - Module 2_Homework.docx',
    type: 'docx',
    moduleId: 2,
    description: 'Module 2 Homework Assignment'
  },
  {
    id: 'module-3-pdf',
    name: 'SJA - Module 3_Excel PPT Wizardry.pdf',
    type: 'pdf',
    moduleId: 3,
    description: 'Module 3 Course Material'
  },
  {
    id: 'module-3-praktek',
    name: 'SJA - Module 3_Praktek.xlsx',
    type: 'xlsx',
    moduleId: 3,
    description: 'Module 3 Practice Exercise'
  },
  {
    id: 'module-3-praktek-answer',
    name: 'SJA - Module 3_Praktek Answer Key.xlsx',
    type: 'xlsx',
    moduleId: 3,
    description: 'Module 3 Practice Exercise Answer Key'
  },
  {
    id: 'module-3-homework',
    name: 'SJA - Module 3_Homework.docx',
    type: 'docx',
    moduleId: 3,
    description: 'Module 3 Homework Assignment'
  },
  {
    id: 'module-3-bonus-homework',
    name: 'SJA - Module 3_Bonus Homework.docx',
    type: 'docx',
    moduleId: 3,
    description: 'Module 3 Bonus Homework Assignment'
  },
  {
    id: 'module-4-pdf',
    name: 'SJA - Module 4_Crystal Clear Comms.pdf',
    type: 'pdf',
    moduleId: 4,
    description: 'Module 4 Course Material'
  },
  {
    id: 'module-4-praktek',
    name: 'SJA - Module 4_Praktek.docx',
    type: 'docx',
    moduleId: 4,
    description: 'Module 4 Practice Exercise'
  },
  {
    id: 'module-4-praktek-answer',
    name: 'SJA - Module 4_Praktek Answer Key.docx',
    type: 'docx',
    moduleId: 4,
    description: 'Module 4 Practice Exercise Answer Key'
  },
  {
    id: 'module-4-homework',
    name: 'SJA - Module 4_Homework.docx',
    type: 'docx',
    moduleId: 4,
    description: 'Module 4 Homework Assignment'
  },
  {
    id: 'module-5-pdf',
    name: 'SJA - Module 5_P&P Management.pdf',
    type: 'pdf',
    moduleId: 5,
    description: 'Module 5 Course Material'
  },
  {
    id: 'module-5-homework',
    name: 'SJA - Module 5_Homework.docx',
    type: 'docx',
    moduleId: 5,
    description: 'Module 5 Homework Assignment'
  },
];

export const downloadModuleFile = async (fileName: string): Promise<void> => {
  try {
    // Create a reference to the file in Firebase Storage
    const fileRef = ref(storage, `coursefiles/${fileName}`);
    
    // Get the download URL
    const downloadURL = await getDownloadURL(fileRef);
    
    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = fileName;
    link.target = '_blank';
    
    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error('Failed to download file. Please try again.');
  }
};

export const getModuleFiles = (moduleId: number): ModuleFile[] => {
  return MODULE_FILES.filter(file => file.moduleId === moduleId);
}; 